/**
 * Hotel Chain List Component
 */

import React from 'react';
import {
  EditButton,
  List,
  NumberField,
  TextField,
  UrlField,
  useTranslate,
} from 'react-admin';
import { Box, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { CustomDatagrid } from '@/components/common';
import { compactListSx } from '@/components/common/compactListSx';
import { actionButtonSx } from '@/components/common/ListPageHeader';

const ChainActions = () => {
  const translate = useTranslate();
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <Button
        onClick={() => navigate('/hotel-chains/create')}
        size="small"
        variant="contained"
        startIcon={<AddIcon />}
        sx={actionButtonSx}
      >
        {translate('common.create')}
      </Button>
    </Box>
  );
};

export const ChainList = () => {
  const translate = useTranslate();
  const f = (key: string) => translate(`resources.hotel-chains.fields.${key}`);

  return (
    <List sx={compactListSx} actions={<ChainActions />} perPage={25}>
      <CustomDatagrid primarySource="name" secondarySource="country" detailColumns={2}>
        <TextField source="name" label={f('name')} />
        <NumberField source="hotelCount" label={f('hotelCount')} sortable={false} />
        <TextField source="country" label={f('country')} />
        <UrlField source="website" label={f('website')} sortable={false} />
        <EditButton />
      </CustomDatagrid>
    </List>
  );
};

export default ChainList;
